import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { ConditionApiModel } from '../Models/ConditionApiModel';
import { SpaContext } from '../../../../Classes/spacontext';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class ConditionServiceV2 {
	baseUri = () => `/api/Client/v2/units/${this.spaContext.unitConfig.Unit.UnitId}/Conditions`;

	constructor(private http: VisibaApiHttp, private spaContext: SpaContext) {
		// Empty
	}

	getAll(licenceHolderId: number, languageCode: string = null) {
		let params = new HttpParams();

		params = params.append('licenceholderId', licenceHolderId.toString());
		if (languageCode !== null) params = params.append('languageCode', languageCode);

		return this.http.getTyped<ConditionApiModel[]>(this.baseUri(), true);
	}
}
